import React from 'react';
import { Star } from 'lucide-react';
export function SocialProof() {
  return <section className="py-10 bg-white border-y border-sage-light/30" data-id="element-125">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0 md:space-x-12" data-id="element-127">
          <div className="flex items-center space-x-2" data-id="element-128">
            <div className="flex -space-x-2" data-id="element-129">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-10 h-10 rounded-full border-2 border-white bg-sage-light overflow-hidden" data-id="element-130">
                  <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="Pet parent" className="w-full h-full object-cover opacity-80 mix-blend-multiply" data-id="element-131" />
                </div>)}
            </div>
            <div className="ml-4" data-id="element-132">
              <div className="flex text-terracotta" data-id="element-133">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-134" />)}
              </div>
              <p className="text-sm font-medium text-gray-900 mt-1" data-id="element-135">
                Confiado por <span className="font-bold" data-id="element-136">10,000+</span> Pet
                Parents
              </p>
            </div>
          </div>

          <div className="hidden md:block w-px h-12 bg-sage-light/50" data-id="element-137"></div>

          <div className="flex items-center space-x-8 opacity-60 grayscale" data-id="element-138">
            {/* Minimalist abstract logos representing features/trust */}
            <div className="flex items-center space-x-2 font-serif font-bold text-xl" data-id="element-139">
              <span className="w-6 h-6 rounded-full bg-gray-800" data-id="element-140"></span>
              <span data-id="element-141">BioVet</span>
            </div>
            <div className="flex items-center space-x-2 font-serif font-bold text-xl" data-id="element-142">
              <span className="w-6 h-6 rotate-45 bg-gray-800" data-id="element-143"></span>
              <span data-id="element-144">NaturaPet</span>
            </div>
            <div className="hidden lg:flex items-center space-x-2 font-serif font-bold text-xl" data-id="element-145">
              <span className="w-6 h-6 rounded-sm bg-gray-800" data-id="element-146"></span>
              <span data-id="element-147">VitalLife</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}